<template>
  <div
    class="tray-tag"
    :style="{
      'background-color': backgroundColor
    }"
    @mouseover="(!hovered ? hover(true) : null)"
    @mouseleave="hover(false)"
    @click.stop
  >
    <label
      class="selection-label"
      :style="{
        'color': textColor
      }"
      v-text="displayObject[displayKey]"
      :title="displayObject[displayKey]"
    />

    <div
      class="icon-div"
      @click="clicked"
    >
      <p4a-icon
        class="remove-icon"
        :icon="'close-modal'"
        :color="textColor"
      />
    </div>
  </div>
</template>

<script>
// import * as _ from 'lodash'
import Vue from 'vue'

export default {
  name: 'TrayTag',
  components: {
  },
  data () {
    return {
      debugActive: false,
      hovered: false
    }
  },
  props: {
    displayKey: {
      default: 'Name',
      type: String
    },
    displayObject: {
      default: function () { return { 'Name': 'placeHolder' } },
      type: Object
    },
    colorData: {
      default: function () {
        return {
          backgroundColor: '#00bbd5',
          backHoverColor: '#00aeef',
          textColor: '#ffffff',
          textHoverColor: '#eeeeee'
        }
      },
      type: Object
    },
    readOnly: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    backgroundColor () {
      let self = this
      return self.hovered ? self.colorData.backHoverColor : self.colorData.backgroundColor
    },
    textColor () {
      let self = this
      return self.hovered ? self.colorData.textHoverColor : self.colorData.textColor
    }
  },
  methods: {
    hover (value) {
      let self = this
      Vue.set(self, 'hovered', value)
    },
    clicked () {
      let self = this
      self.$emit('clicked')
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>

  .tray-tag {
    min-width: 80px;
    height: 25px;
    line-height: 25px;
    display: inline-block;
    text-align: right;
    padding: 0 10px;
    border-radius: 2px;
    vertical-align: top;

    .selection-label {
      display: inline-block;
      vertical-align: middle;
      line-height: 12px;
      font-size: 12px;
      max-width: calc(100% - 17px);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .icon-div {
      cursor: pointer;
      display: inline-block;
      height: 12px;
      line-height: 12px;
      margin-left: 5px;
      vertical-align: middle;
      width: 12px;

      .remove-icon {
        width: 12px;
        height: 12px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/components/SelectionTray/TrayTag.vue